import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { PhaseDrawer } from '../components/UserDashboard/PhaseDrawer';
import { DietHealthDrawer } from '../components/UserDashboard/DietHealthDrawer';
import { UserDashboard } from '../components/UserDashboard/UserDashboard';

export const UserDashboardRoute = () => {
  const navigate = useNavigate();
  const onclose = () => {
    navigate(`/dashboard`);
  };

  return (
    <Routes>
      <Route path="/" element={<UserDashboard />}>
        <Route path=":phase" element={<PhaseDrawer onClose={onclose} />} />
        <Route path="diet" element={<DietHealthDrawer />} />
      </Route>
    </Routes>
  );
};
